<!-- @if (showLoader) {
<div class="progressLoader">
  <progress class="progress is-primary is-small" value="{{defaultProgress}}" max="100" *ngIf="showLoader">15%</progress>
  <div class="paginate-loader"></div>
</div>
} -->
<!-- <div class="spinner" >
<i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw" *ngIf="showLoader"></i>
<span class="sr-only">Loading...</span>
</div> -->

@if (showLoader) {
<div class="progressLoader">
  <div class="paginate-loader"></div>
</div>
}